<template>
  <div class="footer">
    <div class="container c-fff  t-center pa-tb-20 fon-15">
      <div>
        版权所有 上海鹿恒文化传媒 <br>
        法律顾问：宗伟刚律师<br>
        <a class="c-fff" href="https://beian.miit.gov.cn/">沪ICP备16029215号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  background: #fb004d;
  a{
    text-decoration: none;
  }
  .title {
    font-size: 36px;
    font-weight: bold;
    padding: 50px 0;
  }
  .b-b-1-fff{
    border-bottom: 1px solid #fff;
  }
}
</style>